import {IHttpPromise, IHttpService, IPromise} from "angular";
import {getAbsoluteUrl} from "../../utils/urlUtill";
import {Address} from "../model/Address";
import {LetterAddress} from "../../opportunities/address/address-prompt.component";

export class AddressService {
    public static instance = ['$http', '$q', AddressService];

    constructor(private $http: IHttpService,
                private $q: ng.IQService) {
    }

    public verifyAddress = (address: Address): IHttpPromise<Address> => {

        let request = {
            method: 'POST',
            url: getAbsoluteUrl('address/validate'),
            data: address
        };

        return this.$http(request);
    };

    public fetchLetterAddress (customerId, employeeId) : IPromise<LetterAddress> {
        return this.$q.all([
            this.fetchCustomerAddress(customerId),
            this.fetchEmployeeBranchAddress(employeeId)
        ]).then(responses => {
                let letterAddress = new LetterAddress();
                letterAddress.to = responses[0].status === 200 ? responses[0].data : this.getToAddressFallback();
                letterAddress.from = responses[1].status === 200 ? responses[1].data : this.getFromAddressFallback();
                return letterAddress;
        })
    }

    public fetchCustomerAddress(customerId: number): IHttpPromise<Address> {
        return this.fetchAddress("address/customer/" + customerId);
    }

    public fetchEmployeeBranchAddress(employeeId: number): IHttpPromise<Address> {
        return this.fetchAddress("address/employee/" + employeeId + "/branch");
    }

    private getToAddressFallback () : Address {
        return {
            verification : {
                valid : false,
                message : 'failed to obtain address from server'
            }
        }
    }

    private getFromAddressFallback () : Address {
        return {
            verification : {
                valid : false,
                message : 'your branch address is not specified. Please, contact your administrator.'
            }
        }
    }

    private fetchAddress(endpoint: string): IHttpPromise<Address> {
        return this.$http({
            method: 'GET',
            url: getAbsoluteUrl(endpoint)
        });
    }

    public postAddress(customerId: number, address: Address) : IHttpPromise<Address> {
        let request = {
          method: 'POST',
          data: address,
          url: getAbsoluteUrl('customer/' + customerId + '/address/')
        };
        return this.$http(request);
    }
}